/* eslint-disable import/prefer-default-export */

export const US = { cca2: 'US', callingCode: ['1'] };
